import Bullet from '../../Entity/Bullet.js'
import Vector from '../../Vector.js'
import Size from '../../Size.js'


export const TYPE_BULLET_CHANGED = 'bullet_changed'

class BulletChanged {
    
    constructor(data) {
        this.data = data
    }
    
    handle(game) {
        const data = this.data;
        const position = new Vector(data.x, data.y);
       
        
        let bullet = null;
        if(!game.getBullets().hasId(data.id)) {
             bullet = new Bullet(data.id, data.radius, position);
             game.getBullets().add(bullet);
        } else {
            bullet = game.getBullets().getById(data.id);
        }
        
        bullet
            .setRadius(data.radius)
            .setPosition(position)
    }
    
}

export default BulletChanged
